export const INITIAL_PATIENT_RECORDS_PAGE = 1;
